export default __webpack_public_path__ + "static/media/404.5c1269c8.svg";